export const materials = () => {

  let columns = $('.materials--table').data('columns');
  let columnWidth = $('.materials--table--cell').not('.materials--table--cell--category').outerWidth();
  let offset = 0;
  let tableWidth = $('.materials--table').outerWidth();
  let displaying = Math.floor(tableWidth / columnWidth);

  $('.materials--paginate--left').on("click", function (e) {

    e.preventDefault();

    if ($(this).hasClass('is-disabled')) {
      return;
    }

    offset -= 1;

    let translateAmount = columnWidth * offset;

    $('.materials--table--cell').not('.materials--table--cell--category').css('transform', 'translateX(-'+translateAmount+'px)');

    if (offset === 0) {
      $(this).addClass('is-disabled');
    }

    $('.materials--paginate--right').removeClass('is-disabled');

  });

  $('.materials--paginate--right').on("click", function (e) {

    e.preventDefault();

    if ($(this).hasClass('is-disabled')) {
      return;
    }

    offset += 1;

    let translateAmount = columnWidth * offset;

    $('.materials--table--cell').not('.materials--table--cell--category').css('transform', 'translateX(-'+translateAmount+'px)');

    if ((offset + displaying) === columns) {
      $(this).addClass('is-disabled');
    }

    $('.materials--paginate--left').removeClass('is-disabled');

  });

  if ( $('.materials--list--dropdown').length > 0 ) {

    $('.materials--list--dropdown').on('change', function(e) {
      e.preventDefault();
      filterMaterials();
    });
  
  }
  
  function filterMaterials() {
  
    var classesArray   = [];
    var materialsItems = $('.materials--list--item');
  
    $('.materials--list--dropdown').each(function(){
  
      var selectClass = $(this).val();
  
      if (selectClass) {
        classesArray.push(selectClass);
      }
  
    });
  
    if (classesArray.length > 0) {
  
      materialsItems.each(function() {
  
        var shouldHide = false;
        var materialsItem  = $(this);
  
        $.each(classesArray, function(i,val) {
  
          if ( !materialsItem.hasClass(val) ) {
            shouldHide = true;
          }
  
        });
  
        if (shouldHide) {
          $(this).addClass('is-hiding');
        } else {
          $(this).removeClass('is-hiding');
        };
  
      });
  
    } else {
  
      materialsItems.removeClass('is-hiding');
  
    }
  
    materialsItems.addClass('over');
  
  }
    

}